import { BrowserRouter, Routes, Route } from "react-router-dom";
import { LanguageProvider } from "@/context/LanguageContext";
import { Toaster } from "@/components/ui/sonner";
import Navigation from "@/components/Navigation";
import Hero from "@/components/Hero";
import Story from "@/components/Story";
import Properties from "@/components/Properties";
import Amenities from "@/components/Amenities";
import Location from "@/components/Location";
import Region from "@/components/Region";
import VideoSection from "@/components/VideoSection";
import BookingForm from "@/components/BookingForm";
import Footer from "@/components/Footer";
import WhatsAppFab from "@/components/WhatsAppFab";

function Home() {
  return (
    <main className="relative bg-[#FAFAF7] min-h-screen overflow-x-hidden">
      <Navigation />
      <Hero />
      <Story />
      <VideoSection />
      <Properties />
      <Amenities />
      <Location />
      <Region />
      <BookingForm />
      <Footer />
      <WhatsAppFab />
      <Toaster position="top-right" />
    </main>
  );
}

function App() {
  return (
    <LanguageProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
        </Routes>
      </BrowserRouter>
    </LanguageProvider>
  );
}

export default App;
